export const SOURCE_OF_FINANCE_STATUS = {
  CASH: 'cash',
  LOAN: 'bank_loan',
};

export const SOURCE_OF_FINANCE_STATUSES = [
  { text: 'Cash', value: SOURCE_OF_FINANCE_STATUS.CASH },
  { text: 'Loan', value: SOURCE_OF_FINANCE_STATUS.LOAN },
];

export const SOURCE_OF_FINANCE_STATUS_MAP = SOURCE_OF_FINANCE_STATUSES.reduce(
  (acc, tab) => ({
    ...acc,
    [tab.value]: tab,
  }),
  {},
);



// WEBPACK FOOTER //
// ./src/constants/sourceOfFinanceStatuses.js